import { request } from "utils/api";

// court schema
export interface Court {
    advanceBookingMins: number,
    bookingPriceCents: number,
    closeTimeMins: number,
    clubId: string,
    clubName: string,
    courtDescription: string,
    courtName: string,
    courtNumber: number,
    id: string,
    isAlwaysPaidBooking: boolean,
    isBadWeatherSensitive: boolean,
    isCommercialOnlyCourt: boolean,
    minNumParticipants: number,
    openTimeMins: number,
    sportForms: string[],
    surfaceType: "clay" | "asphalt" | "grass" | "hard" | "woodchip" | "artificial-grass" | "plastic-floor" | "sand" | "tartan" | "carpet" | "carpet-with-granulate" | "carpet-fleece" | "table-tennis-indoor" | "table-tennis-stone",
    latitude: string,
    longitude: string,
}

// sport form
export interface SportForm {
    available: true,
    name: string,
}

// fetch general sport forms (GET /general/sport-forms)
export const getSportForms = () => request<SportForm[]>({
    endpoint: "/general/sport-forms",
    method: "get",
});
